import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BehaviorSubject, Observable } from 'rxjs';

import { AccountLocation } from 'src/app/models/location.interface';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  public location: AccountLocation = {
    city: '',
    countryCode: '',
    localCurrentDate: '',
    phone: '',
    state: '',
    streetAddress1: '',
    streetAddress2: '',
    zip: '',
    currentCultureDecimalSeparator: '',
    email: '',
    address: ''
  };

  private locationSub$: BehaviorSubject<AccountLocation> = new BehaviorSubject<AccountLocation>(this.location);
  location$: Observable<AccountLocation> = this.locationSub$.asObservable();

  constructor(
    private http: HttpClient
  ) {}

  getAccountLocation(): Observable<AccountLocation> {
    return this.http.get<AccountLocation>('api/locations');
  }

  setAccountLocation(location: AccountLocation): void {
    this.location = location;
    this.locationSub$.next(location);
  }
}
